import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Stops, TypeReport2 } from 'src/app/data/model/custom-report';

@Component({
  standalone: false,
  selector: 'app-stops-dialog',
  templateUrl: './stops-dialog.component.html',
  styleUrls: ['./stops-dialog.component.scss']
})
export class StopsDialogComponent implements OnInit {
  tooltipText: string = '';
  public get displayedColumns(): string[] {
    return ['inizio_fermata', 'fine_fermata', 'minuti_fermata']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TypeReport2
  ) { }

  
  ngOnInit(): void {
  }
  

  showTooltip(text: string) {
    this.tooltipText = text;
  }

  hideTooltip() {
    this.tooltipText = '';
  }
}
export type StopsDialogParams = {
  data: any;
};
